import { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { dashboardStore } from 'store/DashboardStore';
import { formatAmount, getDocumentType, toBase64 } from '../../utils';

const SipPayMethod = ({ show, onClick,setPaymentMethod,paymentMethod ,setIsDisplayPayMethod}) => {
  // const [paymentMethod, setPaymentMethod] = useState('CUSTOMER_WALLET');
  const [summary] = dashboardStore((state: any) => [state.summary]);

  /**
   * Set payment method value
   * @param e
   */
  const onChangePaymentMethod = async (e) => {
    const { value } = e.target;
    setPaymentMethod(value);
  };
  const closeFunc = ()=>{
    setIsDisplayPayMethod(false)
  }

  return (
    <Modal show={show} onHide={()=>closeFunc()} aria-labelledby='contained-modal-title-vcenter' centered>
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>
          Payment Method
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* <Form.Group className='mb-3' controlId='paymentMethod'>
          <Form.Label>Payment Method</Form.Label>
          <Form.Select
            aria-label='Default select example'
            onChange={onChangePaymentMethod}
          >
            <option value='CUSTOMER_WALLET'>
              Wallet - ₹ {formatAmount(summary?.walletBalance)}
            </option>
            <option value='UPI'>UPI</option>
            <option value='NEBK'>Net Banking</option>
          </Form.Select>
        </Form.Group> */}
        <Form className='radio-div '>
          
          <Form.Check
            type='radio'
            label='UPI'
            name='payment-group'
            value={'UPI'}
            onChange={(e) => setPaymentMethod(e.target.value)}
            checked={paymentMethod == 'UPI'}
          ></Form.Check>
          <Form.Check
            type='radio'
            label='Net Banking'
            name='payment-group'
            value={'NEBK'}
            onChange={(e) => setPaymentMethod(e.target.value)}
            checked={paymentMethod == 'NEBK'}
          ></Form.Check>
          <Form.Check
            type='radio'
            label='Wallet'
            name='payment-group'
            value={'CUSTOMER_WALLET'}
            onChange={(e) => setPaymentMethod(e.target.value)}
            checked={paymentMethod == 'CUSTOMER_WALLET'}
          ></Form.Check>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant='primary'
          size='sm'
          onClick={() => onClick(paymentMethod)}
        >
          Proceed
        </Button>
        {/* <div className='d-grid mb-3'>
          <Button
            variant='primary'
            onClick={() => checkPanRequirement(true, 'SELL')}
            className=''
            size='lg'
          >
            Proceed
          </Button>
        </div> */}
      </Modal.Footer>
    </Modal>
  );
};

export default SipPayMethod;
